import React from 'react';
import { useNavigate } from 'react-router-dom';
import { mixed, object, string } from 'yup';

import Cabecalho from 'Component/Admin/Cabecalho';
import { useToast } from 'Component/Alerta';
import BotaoLink from 'Component/BotaoLink';
import Form, {
  Botao,
  Campo,
  Editor,
  Selecao,
} from 'Component/Form';
import Icone from 'Component/Icone';
import UnidadeDeAprendizagem from 'Interface/UnidadesDeAprendizagem';
import {
  useRecuperarCategoriasQuery,
} from 'Service';
import { useAdicionarUnidadeDeAprendizagemMutation } from 'View/Service/Default/UnidadesDeAprendizagem';

const regras = object({
  titulo: string().required('Obrigatório'),
  descricao: mixed().test('obrigatorio2', 'Obrigatório', (valor) => {
    if (valor?.blocks?.length && valor.blocks[0].text) {
      return true;
    }

    return false;
  }),
  competencias: mixed().test('obrigatorio', 'Obrigatório', (valor) => {
    if (valor?.blocks?.length && valor.blocks[0].text) {
      return true;
    }

    return false;
  }),
  video: string().url('Não é uma URL válida').required('Obrigatório'),
  video_apple: string().url('Não é uma URL válida').required('Obrigatório'),
});

const Adicionar = (): React.ReactElement => {
    const { data } = useRecuperarCategoriasQuery({
      finder: 'listaJson',
      limit: 100,
      sort: 'nome',
    });

  const navegacao = useNavigate();
  const toast = useToast();
  const [adicionarUnidade] = useAdicionarUnidadeDeAprendizagemMutation();

  const enviar = async (dados: UnidadeDeAprendizagem): Promise<void> => {
    try {
      await adicionarUnidade(dados).unwrap();

      toast({ conteudo: 'Adicionado com sucesso!', tema: 'success' });

      navegacao('/admin/unidades-de-aprendizagem');
    } catch (error) {
      toast({
        titulo: 'Erro ao adicionar',
        conteudo: 'Verifique os logs para maiores detalhes.',
        tema: 'danger',
      });
    }
  };

  return (
    <div className="animate__animated animate__fadeIn">
      <Cabecalho
        titulo="Adicionando unidade de aprendizagem"
        descricao="Preencha o formulário e clique em enviar para cadastrar uma nova unidade de aprendizagem"
      />
      <Form onSubmit={enviar} regras={regras}>
        <div className="row justify-content-center">
          <div className="col-md-7">
            <div className="bg-white shadow-sm rounded p-4">
              <div className="row">
                <div className="col-md-12">
                  <Campo name="titulo" rotulo="Título" />
                </div>
                <div className="col-md-12">
                    <Selecao
                      name="categoria_id"
                      rotulo="Categoria"
                      opcoes={data?.categorias}
                      prefixar={<Icone nome="view-list" />}
                    />
                  </div>
                <div className="col-md-12">
                  <Campo
                    name="video"
                    rotulo="URL do vídeo (Android e Windows)"
                    ajuda="Deve estar em um formato compatível com DASH"
                    prefixar={<Icone nome="link" />}
                  />
                </div>
                <div className="col-md-12">
                  <Campo
                    name="video_apple"
                    rotulo="URL do vídeo (Apple)"
                    ajuda="Deve estar em um formato compatível com HLS para dispositivos Apple"
                    prefixar={<Icone nome="link" />}
                  />
                </div>
                <div className="col-md-12">
                  <Editor name="descricao" rotulo="Descrição" />
                </div>
                <div className="col-md-12">
                  <Editor name="competencias" rotulo="Competências" />
                </div>
              </div>
              <Botao>Enviar</Botao>{' '}
              <BotaoLink tema="light" to="/admin/unidades-de-aprendizagem">
                Cancelar
              </BotaoLink>
            </div>
          </div>
        </div>
      </Form>
    </div>
  );
};

export default Adicionar;
